export default __webpack_public_path__ + "static/media/bollywood-songs.63205f90.jpeg";